import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state    : {
        peripheralInfo: {},
        deviceInfo    : {},
        notifyData    : {}
    },
    mutations: {
        ["peripheralInfo"](state, payload) {
            state.peripheralInfo = {...payload}
        },

        ["deviceInfo"](state, payload) {
            state.deviceInfo = {...payload}
        },

        ["notifyDataChanged"](state, payload) {
            state.notifyData = {...state.notifyData, ...payload}
        }
    }
})


export default store